import { defineComponent as _defineComponent } from 'vue'
import { cva } from 'class-variance-authority'
import { RouterLink } from 'vue-router'
import AppIcon from '../icon/AppIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppButton',
  props: {
  size: { default: 'md' },
  variant: { default: 'filled' },
  disabled: { type: Boolean, default: false },
  type: { default: 'button' },
  state: null,
  to: { default: '#' },
  external: { type: Boolean, default: false },
  loading: { type: Boolean, default: false }
},
  emits: ["click", "mouseenter", "mouseleave"],
  setup(__props, { emit }) {

const props = __props;





const styles = cva(
  [
    'tw-inline-flex tw-flex-row tw-items-center tw-justify-center tw-rounded-full tw-transition-colors',
    'disabled:tw-cursor-not-allowed',
  ],
  {
    variants: {
      size: {
        sm: ['tw-h-9 tw-max-h-9 tw-gap-2 tw-px-4 tw-text-sm', '[&>svg]:tw-h-[18px] [&>svg]:tw-w-[18px]'],
        md: ['tw-h-10 tw-max-h-10 tw-gap-2 tw-px-6 tw-text-sm', '[&>svg]:tw-h-5 [&>svg]:tw-w-5'],
        lg: ['tw-h-12 tw-max-h-12 tw-gap-2 tw-px-8 tw-text-base', '[&>svg]:tw-h-5 [&>svg]:tw-w-5'],
      },
      variant: {
        filled: [
          'tw-bg-primary tw-text-secondary-lightest',
          'hover:tw-bg-primary-dark',
          'active:tw-bg-primary-darkest',
          'disabled:tw-bg-blue-gray-50 disabled:tw-text-disabled',
          '[&>svg]:tw-fill-secondary-lightest [&>svg]:disabled:tw-fill-neutral-light',
        ],
        outlined: [
          'tw-border tw-border-solid tw-border-outline-dark tw-bg-surface-lightest tw-text-body-1',
          'hover:tw-border-primary hover:tw-bg-secondary-light hover:tw-text-primary',
          'active:tw-bg-secondary',
          'disabled:tw-border-outline-light disabled:tw-bg-surface-lightest disabled:tw-text-disabled',
          '[&>svg]:tw-fill-neutral-dark [&>svg]:hover:tw-fill-primary [&>svg]:disabled:tw-fill-neutral-light',
        ],
        text: [
          'tw-bg-surface-lightest tw-text-primary',
          'hover:tw-bg-secondary-light hover:tw-text-primary',
          'active:tw-bg-secondary',
          'disabled:tw-bg-surface-lightest disabled:tw-text-disabled',
          '[&>svg]:tw-fill-primary [&>svg]:hover:tw-fill-primary [&>svg]:disabled:tw-fill-neutral-light',
        ],
      },
      state: {
        active: [],
        hover: [],
        disabled: [],
      },
    },
    compoundVariants: [
      {
        state: 'active',
        variant: 'filled',
        class: 'tw-bg-primary-darkest',
      },
      {
        state: 'hover',
        variant: 'filled',
        class: 'tw-bg-primary-dark',
      },
      {
        state: 'disabled',
        variant: 'filled',
        class: 'tw-bg-blue-gray-50 !tw-text-disabled [&>svg]:tw-fill-neutral-light',
      },
      {
        state: 'active',
        variant: 'outlined',
        class: '!tw-border-primary !tw-text-primary !tw-bg-secondary [&>svg]:!tw-fill-primary',
      },
      {
        state: 'hover',
        variant: 'outlined',
        class: 'tw-border-primary tw-bg-secondary-light !tw-text-primary [&>svg]:tw-fill-primary',
      },
      {
        state: 'disabled',
        variant: 'outlined',
        class: 'tw-border-outline-light tw-bg-surface-lightest !tw-text-disabled [&>svg]:tw-fill-neutral-light',
      },
      {
        state: 'active',
        variant: 'text',
        class: '!tw-text-primary !tw-bg-secondary [&>svg]:tw-fill-primary',
      },
      {
        state: 'hover',
        variant: 'text',
        class: 'tw-bg-secondary-light !tw-text-primary [&>svg]:tw-fill-primary',
      },
      {
        state: 'disabled',
        variant: 'text',
        class: 'tw-bg-surface-lightest !tw-text-disabled [&>svg]:tw-fill-neutral-light',
      },
    ],
    defaultVariants: {
      variant: 'filled',
      size: 'sm',
    },
  },
)

return { __sfc: true,props, emit, styles, RouterLink, AppIcon }
}

})